export default {
  pageTitle: 'Welding Overlay Service',
  metaDescription: 'TEF provides welding overlay services to restore and protect equipment surfaces, extending the service life of vessels, nozzles and process equipment.',
  sidebar: {
    title: 'Maintenance And Reconditioning list',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reShell: 'Re-Shell',
    reTubing: 'Re-Tubing',
  },
  productName: 'Welding Overlay',
  subheading: 'On-Site Deposit Overlay Welding and Finishing Services',
  paragraph1: 'We offer specialized deposit overlay welding and finishing services, utilizing portable machines that bring precision and efficiency directly to your location. Our process enhances the durability and performance of your components by applying high-quality overlay materials, tailored to meet your specific needs.',
  paragraph2: "Our skilled technicians ensure seamless execution, whether it's for repair, surface enhancement, or corrosion resistance. By performing the work on-site, we minimize downtime and eliminate the need for transporting heavy or complex equipment.",
  paragraph3: 'Experience the convenience of advanced welding and finishing solutions delivered right where you need them.',
  gallery: {
    overlayNozzle: 'Overlay Nozzle',
    machiningSurface: 'Machining Surface',
    overlayChannel: 'Overlay Channel',
    finishingSurface: 'Finishing Surface',
    finishMachiningSurface: 'Finish Machining Surface',
  },
};
